<template>
  <div class="back_btn">
    <img src="@/assets/images/toHomepage.png" @click="toHomepage">
  </div>
</template>

<script>
export default {
  methods: {
    toHomepage(){
      this.$router.push({name: 'Index'})
    }
  }
};
</script>
<style lang="scss" scoped>
  .back_btn{
    position: fixed;
    left: 0;
    bottom: 140px;
    height: 52px;
    width: 200px;
    img {
      width: 100%;
    }
  }
</style>